import { render, staticRenderFns } from "./PatientGeneralForm.vue?vue&type=template&id=041d8055&"
import script from "./PatientGeneralForm.vue?vue&type=script&lang=js&"
export * from "./PatientGeneralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports